import {
  AutocompleteArrayInput,
  DatagridConfigurable,
  DeleteWithConfirmButton,
  FilterButton,
  FunctionField,
  List,
  ReferenceArrayInput,
  SearchInput,
  SelectColumnsButton,
  SelectInput,
  ShowButton,
  TextField,
  TopToolbar,
  useNotify,
  WrapperField,
} from "react-admin";

import LocalisedDateField from "../components/localisedDateField";
import StartDateEndDateInput from "../components/startDateEndDateInput";
import grapheneDataProvider from "../providers/grapheneDataProvider2";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
  </TopToolbar>
);

const filterToQuery = (searchText: string) => ({ name__icontains: `${searchText}`, active: true });

const userFilters = [
  <SearchInput source="email__icontains" alwaysOn={true} placeholder="Email" />,
  <SearchInput source="firstName__icontains" placeholder="First Name" alwaysOn={true} />,
  <SearchInput source="lastName__icontains" placeholder="Last Name" alwaysOn={true} />,
  <ReferenceArrayInput source="country__in" reference="allCountries" alwaysOn perPage={100}>
    <AutocompleteArrayInput label="Country in" filterToQuery={filterToQuery} optionText={"name"} />
  </ReferenceArrayInput>,
  <ReferenceArrayInput source="language__in" reference="allLanguages" alwaysOn perPage={100}>
    <AutocompleteArrayInput label="Language in" filterToQuery={filterToQuery} optionText={"name"} />
  </ReferenceArrayInput>,
  <SearchInput source="oldEmail" placeholder="Old Email" />,
  <SelectInput
    label="Test User"
    source="isTest"
    choices={[
      { id: true, name: "Test" },
      { id: false, name: "Real" },
    ]}
  />,
  <StartDateEndDateInput source="createdAt" />,
  <StartDateEndDateInput source="subscriptionStart" />,
  <StartDateEndDateInput source="subscriptionEnd" />,
];
const DeleteButtonWithMessage = () => {
  const notify = useNotify();
  const onError = (data: any) => {
    notify(
      <span
        style={{
          fontFamily: "Comic Sans MS",
          fontSize: "24px",
          backgroundColor: "red",
          color: "white",
          padding: "5px 10px 5px 10px",
        }}
      >
        <img
          src="https://emoji.slack-edge.com/T03NV6ZDN/judging_paddy/033f47280f298f8a.png"
          height="40px"
          title="Judging Paddy"
          style={{ paddingRight: "5px", marginBottom: "-10px" }}
        />
        You can't do that ....
      </span>,
      { type: "error" }
    );
    // notify(data, { type: "error" });
  };
  return (
    <DeleteWithConfirmButton
      mutationOptions={{ onError }}
      confirmColor="warning"
      confirmContent="Are you sure you want to delete this user?"
    />
  );
};

const UsersList = (props: any) => {
  return (
    <List
      {...props}
      actions={<ListActions />}
      dataProvider={grapheneDataProvider}
      filters={userFilters}
      title={"Customers"}
      sort={{ field: "createdAt", order: "DESC" }}
    >
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="email" />
        <TextField source="firstName" />
        <TextField source="lastName" />
        <TextField source="countryEmoji" sx={{ fontSize: "24px" }} label="Country" sortBy="country" />
        <TextField source="language" />
        <FunctionField
          label="Subscription Start"
          render={(record: any) => {
            return <LocalisedDateField record={record} field="subscriptionStart" compact />;
          }}
        />
        <FunctionField
          label="Subscription End"
          render={(record: any) => {
            return <LocalisedDateField record={record} field="subscriptionEnd" compact />;
          }}
        />
        <FunctionField
          label="Created"
          render={(record: any) => {
            return <LocalisedDateField record={record} field="createdAt" compact />;
          }}
        />
        <FunctionField
          label="Last Login"
          render={(record: any) => {
            return <LocalisedDateField record={record} field="lastLogin" compact />;
          }}
        />
        <WrapperField label="Actions">
          <ShowButton />
          <DeleteButtonWithMessage />
        </WrapperField>
      </DatagridConfigurable>
    </List>
  );
};

export default UsersList;
